export var AvatarGenerationUserLimit;
(function (AvatarGenerationUserLimit) {
    AvatarGenerationUserLimit[AvatarGenerationUserLimit["FREE"] = 100] = "FREE";
    AvatarGenerationUserLimit[AvatarGenerationUserLimit["PREMIUM"] = 500] = "PREMIUM";
})(AvatarGenerationUserLimit || (AvatarGenerationUserLimit = {}));
export var TextMessagesUserLimit;
(function (TextMessagesUserLimit) {
    TextMessagesUserLimit[TextMessagesUserLimit["GUEST"] = 50] = "GUEST";
    TextMessagesUserLimit[TextMessagesUserLimit["FREE"] = 2000] = "FREE";
    TextMessagesUserLimit[TextMessagesUserLimit["PREMIUM"] = 5000] = "PREMIUM";
})(TextMessagesUserLimit || (TextMessagesUserLimit = {}));
